import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=344226f6&scoped=true"
import script from "./UploadAvatar.vue?vue&type=script&lang=js"
export * from "./UploadAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344226f6",
  null
  
)

export default component.exports